import React from 'react';
import classNames from 'classnames';
import StarRating from 'components/shared/StarRating';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { toATLocalString } from 'utils/number_util';
import * as styles from './styles.module.scss';
import StarInactive from '../../../../assets/images/icons/inactive-sml.svg';
import RatingsBreakdown, { RatingKey } from '../types/RatingsBreakdown';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

type ReviewsGraphProps = {
  itemCount: number;
  ratingsBreakdown: RatingsBreakdown;
};

const ReviewsGraph = ({ itemCount, ratingsBreakdown }: ReviewsGraphProps): JSX.Element => {
  const languageRegionCode = useLanguageRegionCode();
  const ratingCounts = ratingsBreakdown;
  if (Object.keys(ratingCounts).length < 1) {
    return null;
  }

  let averageRating = null;
  let ratingsTable = null;
  const nonZeroRatingCount = itemCount;
  const ratingSum = Object.keys(ratingCounts)
    .map((i: RatingKey) => ratingCounts[i] * parseInt(i))
    .reduce((a, b) => a + b);
  if (nonZeroRatingCount > 0) {
    const displayText =
      nonZeroRatingCount === 1
        ? StringConstantsMixin.strings.REVIEW_SINGULAR
        : StringConstantsMixin.strings.REVIEWS_PLURAL.replace('{count}', toATLocalString(nonZeroRatingCount, languageRegionCode));
    const rating = (ratingSum / nonZeroRatingCount).toFixed(1);
    averageRating = (
      <div className={styles.rating}>
        <div className={styles.ratingDisplay}>{rating}</div>
        <StarRating config={rating} />
        <div className={styles.ratingCount}>{displayText}</div>
      </div>
    );

    const rows = [];
    let largestRatingCount = 0;
    Object.keys(ratingCounts).forEach((i: RatingKey) => {
      if (ratingCounts[i] > largestRatingCount) {
        largestRatingCount = ratingCounts[i];
      }
    });
    for (let i = 5; i >= 1; i--) {
      rows.push(
        <tr key={`ratings-${i}`}>
          <td className={styles.label}>{i}</td>
          <td className={styles.star}>
            <img src={StarInactive} alt="" />
          </td>
          <td className={styles.graphBar}>
            <div
              style={{
                width: `${ratingCounts[i.toString() as RatingKey] ? (ratingCounts[i.toString() as RatingKey] * 100.0) / largestRatingCount : 0}%`
              }}
            />
          </td>
        </tr>
      );
    }
    ratingsTable = (
      <div className={styles.ratingsTable}>
        <table>
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  }

  return (
    <div className={classNames(styles.reviewsMobile, styles.invitationContainer)}>
      {ratingsTable}
      {averageRating}
    </div>
  );
};

export default ReviewsGraph;
